<template>
  <div class="singList">
    <div class="singList_xinxi">当前<span v-if="obt.paperLx === 0">试卷</span><span v-if="obt.paperLx === 1">问卷调查</span>信息</div>
    <div class="singList_neirong">
      <div class="singList_neirong_tm">
        <div class="singList_neirong_tm_mingcheng"><span v-if="obt.paperLx === 0">试卷</span><span v-if="obt.paperLx === 1">问卷调查</span>题目：</div>
        <div class="singList_neirong_tm_biaoti">{{obt.paperNr}}</div>
      </div>
      <div class="singList_neirong_real_one" v-if="obt.paperLx === 0">
        <div class="singList_neirong_real_one_Pdt">
          <div class="singList_neirong_real_one_Pdt_mc">判断题数量：</div>
          <div class="singList_neirong_real_one_Pdt_sl">{{obt.paperPdt}}</div>
        </div>
        <div class="singList_neirong_real_one_Tkt">
          <div class="singList_neirong_real_one_Tkt_mc">填空题数量：</div>
          <div class="singList_neirong_real_one_Tkt_sl">{{obt.paperTkt}}</div>
        </div>
      </div>
      <div class="singList_neirong_real_two" v-if="obt.paperLx === 0">
        <div class="singList_neirong_real_two_DxtSingle">
          <div class="singList_neirong_Tkt_mc">单选题数量：</div>
          <div class="singList_neirong_Tkt_sl">{{obt.paperDxtSingle}}</div>
        </div>
        <div class="singList_neirong_real_two_DxtMultiple">
          <div class="singList_neirong_Tkt_mc">多选题数量：</div>
          <div class="singList_neirong_Tkt_sl">{{obt.paperDxtMultiple}}</div>
        </div>
      </div>
      <div class="singList_neirong_real_tree" v-if="obt.paperLx === 0">
        <div class="singList_neirong_real_tree_zf_biaoti">总分：</div>
        <div class="singList_neirong_real_tree_zfs">{{obt.paperZfs}}</div>
        <div class="singList_neirong_real_tree_kssj_biaoti">考试时间：</div>
        <div class="singList_neirong_real_tree_zsj">{{obt.paperZsj}}<span>分钟</span></div>
      </div>
      <div class="singList_neirong_real_four" v-if="obt.paperLx === 1">
        <div class="singList_neirong_real_four_biaoti">{{obt.paperBz}}</div>
      </div>
    </div>
    <div class="singList_ctl">
      <button class="singList_ctl_list" v-on:click="$router.replace('/list')">返回考试列表</button>
      <button class="singList_ctl_btn" v-on:click="startKs(obt.paperId)">开始<span v-if="obt.paperLx === 0">试卷</span><span v-if="obt.paperLx === 1">问卷调查</span></button>
    </div>
    <div class="singList_footer" v-if="obt.paperLx === 0">
      <div  class="singList_footer_title">考试说明：</div>
      <div class="singList_footer_neirong">{{obt.paperBz}}</div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui'
export default {
  name: 'SingleList',
  data () {
    return {
      obt: {}
    }
  },
  mounted () {
    if (!this.$store.state.loginUser) {
      this.$router.replace('/')
      return
    }
    this.$store.state.paper.forEach((item, index) => {
      if (item.paperId === Number.parseInt(this.$route.params.id)) {
        this.obt = item
      }
    })
  },
  methods: {
    startKs (Id) {
      var _this = this
      let msg = '考试'
      if (this.obt.paperLx === 1) {
        msg = '问卷调查'
      }
      MessageBox.confirm('确定开始' + msg + '？').then(function () {
        _this.$store.commit('paperIdChange', _this.obt)
        if (_this.obt.paperLx === 1) {
          _this.$router.replace({path: '/servey/' + Id})
        }
        if (_this.obt.paperLx === 0) {
          _this.$router.replace({path: '/qt/' + Id})
        }
      }).catch(function () {
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .singList
    .singList_xinxi
      margin-bottom: .2rem
      color: #fff
      font-size: .5rem
      height: 2rem
      line-height: 2rem
      background: #00bcd4
      text-align: center
      border-bottom: 1px solid #ccc
    .singList_neirong
      padding: .2rem
      .singList_neirong_tm
        font-size: .35rem
        border-bottom: 1px solid #ccc
        .singList_neirong_tm_mingcheng
          margin-bottom: .2rem
        .singList_neirong_tm_biaoti
          line-height: .5rem
          // text-indent: .8rem
          text-align: center
          font-size: .4rem
          margin-bottom: .1rem
          font-weight:bold
      .singList_neirong_real_one
        font-size: .35rem
        width: 100%
        display: flex
        margin: .2rem 0
        padding-bottom: .1rem
        border-bottom: 1px solid #ccc
        .singList_neirong_real_one_Pdt
          display: flex
          width: 50%
        .singList_neirong_real_one_Tkt
          display: flex
          width: 50%
      .singList_neirong_real_two
        font-size: .35rem
        width: 100%
        display: flex
        margin: .2rem 0
        padding-bottom: .1rem
        border-bottom: 1px solid #ccc
        .singList_neirong_real_two_DxtSingle
          display: flex
          width: 50%
        .singList_neirong_real_two_DxtMultiple
          display: flex
          width: 50%
      .singList_neirong_real_tree
        font-size: .35rem
        width: 100%
        display: flex
        padding-bottom: .1rem
        border-bottom: 1px solid #ccc
        .singList_neirong_real_tree_zf_biaoti
          width: 25%
        .singList_neirong_real_tree_zfs
          width: 25%
        .singList_neirong_real_tree_kssj_biaoti
          width: 28%
        .singList_neirong_real_tree_zsj
          width: 22%
      .singList_neirong_real_four
        font-size: .4rem
        padding: .2rem
        line-height: .6rem
        text-indent: .9rem
        border-bottom: 1px solid #ccc
        .singList_neirong_real_four_biaoti
          text-align:justify
    .singList_ctl
      padding: .2rem .4rem
      display: flex
      text-align: center
      .singList_ctl_btn
        border: 0
        background: #AC2925
        font-size: .35rem
        border-radius: .2rem
        width: 50%
        margin-left: .1rem
        outline: none
        color: white
        box-shadow: .05rem .05rem .05rem #761C19
      .singList_ctl_list
        border: 0
        background: #AC2925
        font-size: .35rem
        border-radius: .2rem
        width: 50%
        margin-right: .1rem
        outline: none
        color: white
        box-shadow: .05rem .05rem .05rem #761C19
    .singList_footer
      padding: .2rem
      .singList_footer_title
        font-size: .2rem
        margin-bottom: .1rem
      .singList_footer_neirong
        font-size: .3rem
        line-height: .4rem
        text-indent: .6rem
</style>



// WEBPACK FOOTER //
// src/singlelist/SingleList.vue